import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const insertStkInwEntry = createAsyncThunk('insertStkInwEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertStkInward`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateMainStkInw = createAsyncThunk('updateMainStkInw', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateMainStockInward`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const insertUserStkInwEntry = createAsyncThunk('insertUserStkInwEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertSchlStockInw`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const insertmanualStkInward = createAsyncThunk('insertmanualStkInward', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertManualSchoolStkinwardEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateItemEntry = createAsyncThunk('updateItemEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateItem`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSktMemo = createAsyncThunk('fetchSktMemo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getStk_memo`);

        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchStkInwData = createAsyncThunk('fetchStkInwData', async ({ id, userId, fdt, tdt } = {}) => {
    try {
        let endpoint = (fdt && tdt) ? `getStkInwardDateWise` : `getStkInwardlist`;

        // Build query parameters properly
        const params = [];
        if (id) params.push(`stkId=${id}`);
        if (userId) params.push(`userId=${userId}`);
        if (fdt) params.push(`fromdt=${fdt}`);
        if (tdt) params.push(`todt=${tdt}`);

        if (params.length > 0) {
            endpoint += `&${params.join('&')}`;
        }

        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});



export const fetchStockItemlist = createAsyncThunk('fetchStockItemlist', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getStockItemslist`);
        console.log(response,"res form fetchStockItemlist");
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchUserStkInwData = createAsyncThunk('fetchUserStkInwData', async ({ id, userId, schlId } = {}) => {
    try {
        // Base endpoint
        let endpoint = schlId ? `getSchlStkInwByschlId` : 'getSchlStockInwData';

        // Build query parameters
        const params = [];
        if (id) params.push(`stkId=${id}`);
        if (userId) params.push(`userId=${userId}`);
        if (schlId) params.push(`schlId=${schlId}`);

        // Full API call
        const fullEndpoint = params.length > 0
            ? `${endpoint}&${params.join('&')}`
            : endpoint;
            // console.log(fullEndpoint)
        const response = await axios.get(`${baseUrl}?apicall=${fullEndpoint}`);
        // console.log(response?.data);

        return response.data;
    } catch (error) {
        throw error;
    }
});



export const fetchSchlStockDetails = createAsyncThunk('fetchSchlStockDetails', async ({ id, fdt, tdt, userId, schlId } = {}) => {
    try {
        // let endpoint = id ? `getSchlwiseStockDetails&userId=${id}` : `getSchlwiseStockDetails`;
        let endpoint = (fdt && tdt || userId || schlId) ? `getSchoolStkSizewisebyDate` : `getSchlwiseStockDetails`;
        const params = [];
        if (id) params.push(`userId=${id}`);
        if (fdt) params.push(`fromdt=${fdt}`);
        if (tdt) params.push(`todt=${tdt}`);
        if (userId) params.push(`userId=${userId}`);
        if (schlId) params.push(`schlId=${schlId}`);

        const fullEndpoint = params.length > 0
            ? `${endpoint}&${params.join('&')}`
            : endpoint;

        const response = await axios.get(`${baseUrl}?apicall=${fullEndpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const deleteStkInw = createAsyncThunk('deleteStkInw', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteStkinward&stkId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

const stkInwSlice = createSlice({
    name: 'stkInwData',
    initialState: {
        isLoading: false,
        smemo: null,
        stkdata: null,
        stkItems: null,
        ustkdata: null,
        ustkdetails: null,
        delstk: null,
        isError: false
    },

    extraReducers: (builder) => {

        builder.addCase(fetchSktMemo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSktMemo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.smemo = action.payload;
        });
        builder.addCase(fetchSktMemo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchStkInwData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStkInwData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.stkdata = action.payload;
        });
        builder.addCase(fetchStkInwData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchStockItemlist.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStockItemlist.fulfilled, (state, action) => {
            state.isLoading = false;
            state.stkItems = action.payload;
        });
        builder.addCase(fetchStockItemlist.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchUserStkInwData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchUserStkInwData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.ustkdata = action.payload;
        });
        builder.addCase(fetchUserStkInwData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchSchlStockDetails.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSchlStockDetails.fulfilled, (state, action) => {
            state.isLoading = false;
            state.ustkdetails = action.payload;
        });
        builder.addCase(fetchSchlStockDetails.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteStkInw.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteStkInw.fulfilled, (state, action) => {
            state.isLoading = false;
            state.delstk = action.payload;
        });
        builder.addCase(deleteStkInw.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default stkInwSlice.reducer;
